import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { VersionLog } from './model/version-log';
import { environment } from '../../environment/environment';
import { QueryBase } from '../../common/model/query-base';
@Injectable({
  providedIn: 'root',
})
export class VersionLogService {
  private versionServiceEndpoint = environment.APIBase + 'Versioning';

  // Injecting HttpClient to handle HTTP requests and interact with the backend API.
  constructor(private httpContext: HttpClient) {
  }

  public getVersionLog(): Promise<VersionLog[]> {
    const query = new QueryBase()
    query.top = 50;
    query.skip = 0;
    return new Promise<VersionLog[]>((resolve, reject) => {
        this.httpContext
        .post(this.versionServiceEndpoint + '/query', query)        // Use `map` to cast the response to the `VersionLog[]` model
        .pipe(map((res) => res as VersionLog[]))
        .subscribe(
          (res: VersionLog[]) => {
            resolve(res); // Resolve the promise with the retrieved customer balance
          },
          (error) => {
            console.error('Error in getVersionLog', error); // Log any errors to the console
            reject(error); // Reject the promise if an error occurs
          }
        );
    });
  }
}
